import { render, staticRenderFns } from "./go-top.vue?vue&type=template&id=22506785&scoped=true"
import script from "./go-top.vue?vue&type=script&lang=js"
export * from "./go-top.vue?vue&type=script&lang=js"
import style0 from "./go-top.vue?vue&type=style&index=0&id=22506785&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22506785",
  null
  
)

export default component.exports